import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ChatHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="wc-header">
      <button className="wc-header__back" onClick={() => navigate(-1)}>
        <ArrowLeft size={20} />
      </button>
      <h3 className="wc-header__title">Chat</h3>
    </div>
  );
};

export default ChatHeader;